/**
 * Master v5 Prompt 17 — client-side ViewAsSession storage.
 *
 * Session-scoped (sessionStorage, not localStorage) on purpose — mirrors
 * the backend's own "the raw token is only ever returned once, at start
 * time" convention by never persisting it beyond this browser tab/session.
 * rehearsalRoomAuth.js's `rrFetch` reads this to attach the
 * X-View-As-Session/X-View-As-Token headers automatically.
 */
import { queryClient } from "./queryClient";

const VIEW_AS_KEY = "rr_view_as_session";
export const VIEW_AS_CHANGED_EVENT = "rr-view-as-changed";

export function getViewAsSession() {
  const raw = sessionStorage.getItem(VIEW_AS_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (new Date(parsed.expires_at).getTime() <= Date.now()) {
      sessionStorage.removeItem(VIEW_AS_KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function setViewAsSession(session) {
  sessionStorage.setItem(VIEW_AS_KEY, JSON.stringify(session));
  // Fix (Prompt 28 hardening): entering View as Client re-uses the exact
  // same workspaceId-scoped query keys as the coach's own normal view —
  // without a clear, any already-cached data from the coach's own
  // capabilities (e.g. edit affordances) could flash stale before the
  // read-only refetch lands. The backend already 403s any real mutation
  // regardless, but the UI should never show it in the first place.
  queryClient.clear();
  window.dispatchEvent(new Event(VIEW_AS_CHANGED_EVENT));
}

export function clearViewAsSession() {
  sessionStorage.removeItem(VIEW_AS_KEY);
  queryClient.clear();
  window.dispatchEvent(new Event(VIEW_AS_CHANGED_EVENT));
}
